import { Controller } from "@hotwired/stimulus"
import { inHomeHeroSection } from "../utils/home_hero_heading"

// Homepage only: transparent nav while the hero section is in view; solid once scrolled past it.
export default class extends Controller {
  static values = {
    buffer: { type: Number, default: 12 }
  }

  connect() {
    this.overlayActive = null
    this.onScroll = this.onScroll.bind(this)
    this.onResize = this.onResize.bind(this)
    window.addEventListener("scroll", this.onScroll, { passive: true })
    window.addEventListener("resize", this.onResize, { passive: true })
    this.update()
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll)
    window.removeEventListener("resize", this.onResize)
  }

  onScroll() {
    this.update()
  }

  onResize() {
    this.update()
  }

  update() {
    const hero = document.getElementById("home-hero")
    if (!hero) return

    const inHeroOverlay = inHomeHeroSection(this.element, this.bufferValue)

    if (inHeroOverlay === this.overlayActive) return
    this.overlayActive = inHeroOverlay

    this.element.classList.toggle("home-hero-nav--overlay", inHeroOverlay)
    this.element.classList.toggle("home-hero-nav--solid", !inHeroOverlay)
  }
}
